import {EventEmitter, Injectable, Output} from '@angular/core';

@Injectable()
export class SingleReportService {
  @Output() deactivateTopMenuActivePosition = new EventEmitter<boolean>();
  constructor() { }

}
